interface NumberBadgeProps {
  number: number | string;
  className?: string;
}

const NumberBadge = ({ number, className }: NumberBadgeProps) => {
  return (
    <span
      className={`badge bg-danger rounded-pill d-flex align-items-center text-black ${className}`}
    >
      {number}
    </span>
  );
};

export default NumberBadge;
